module.exports = __webpack_public_path__ + "img/grade14.771768a7.png";